import React from 'react';
import { getBezierPath } from '@xyflow/react';

export const TurboEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <path
        id={id}
        className="react-flow__edge-path turbo-edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        style={style}
      />
      <path
        className="react-flow__edge-path turbo-edge-path-glow"
        d={edgePath}
      />
    </>
  );
};
